<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-customer-sidenav />

      <div class="layout-container">
        <app-layout-customer-navbar />

        <div class="layout-content">
          <div
            class="router-transitions container-fluid flex-grow-1 container-p-y"
          >
            <router-view />
          </div>
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
import LayoutCustomerNavbar from "./LayoutCustomerNavbar";
import LayoutCustomerSidenav from "./LayoutCustomerSidenav";
import LayoutFooter from "./LayoutFooter";

export default {
  name: "app-layout-1",
  components: {
    "app-layout-customer-navbar": LayoutCustomerNavbar,
    "app-layout-customer-sidenav": LayoutCustomerSidenav,
    "app-layout-footer": LayoutFooter,
  },

  mounted() {
    this.layoutHelpers.init();
    this.layoutHelpers.update();
    this.layoutHelpers.setAutoUpdate(true);
  },

  beforeDestroy() {
    this.layoutHelpers.destroy();
  },

  methods: {
    closeSidenav() {
      this.layoutHelpers.setCollapsed(true);
    },
  },
};
</script>
